import React from 'react';
import { AccountSideNavBar } from './account-side-nav-bar';
import { AccountTopNavBar } from './account-top-nav-bar';
import { useAccountNavBar } from './use-account-nav-bar';

enum NavBarVariant {
  side = 'side',
  top = 'top',
}

type AccountNavBarProps = {
  variant: NavBarVariant;
  user?: any;
};

export function AccountNavBar(props: AccountNavBarProps): JSX.Element | null {
  const { variant, user } = props;
  const {
    isReady,
    selectedTab,
    accountRoutes,
    shouldDisplayDutchiePaySection,
    shouldDisplayLoyaltySection,
    shouldDisplayReferralsSection,
    shouldDisplayPrepaidWalletSection,
  } = useAccountNavBar();

  if (!isReady || !accountRoutes || typeof selectedTab !== 'string') {
    return null;
  }

  if (variant === NavBarVariant.top) {
    return (
      <AccountTopNavBar
        accountRoutes={accountRoutes}
        selectedTab={selectedTab}
        shouldDisplayDutchiePaySection={shouldDisplayDutchiePaySection}
        shouldDisplayLoyaltySection={shouldDisplayLoyaltySection}
        shouldDisplayReferralsSection={shouldDisplayReferralsSection}
        shouldDisplayPrepaidWalletSection={shouldDisplayPrepaidWalletSection}
      />
    );
  }

  return (
    <AccountSideNavBar
      user={user}
      accountRoutes={accountRoutes}
      selectedTab={selectedTab}
      shouldDisplayDutchiePaySection={shouldDisplayDutchiePaySection}
      shouldDisplayLoyaltySection={shouldDisplayLoyaltySection}
      shouldDisplayReferralsSection={shouldDisplayReferralsSection}
      shouldDisplayPrepaidWalletSection={shouldDisplayPrepaidWalletSection}
    />
  );
}
